import { Text } from "@fragments";

import "./styles.scss";

export default function PresetsSidebar({ presets, activeId, onPick }) {
    return (
        <ul className="dpi-presets">
            {presets.map((p) => {
                const isActive = p.id === activeId;
                return (
                    <li key={p.id}>
                        <button
                            type="button"
                            className={`dpi-presets__item ${isActive ? "is-active" : ""}`}
                            onClick={() => onPick(p.id)}
                        >
                            <Text.span contrast={isActive ? 1 : 8}>
                                {p.label}
                            </Text.span>
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}
